export type FaceScanModel = 'medsi' | 'binah';

const VALID_MODELS: FaceScanModel[] = ['medsi', 'binah'];

export function getFaceScanModel(): FaceScanModel {
  const raw = (process.env.REACT_APP_FACE_SCAN_MODEL ?? 'medsi')
    .trim()
    .toLowerCase();

  if (VALID_MODELS.includes(raw as FaceScanModel)) {
    return raw as FaceScanModel;
  }

  return 'medsi';
}

export function isMedsiFaceScanModel(): boolean {
  return getFaceScanModel() === 'medsi';
}

export function isBinahFaceScanModel(): boolean {
  return getFaceScanModel() === 'binah';
}
